import React from "react";
import Styles from "./LoadingSpinner.module.css";

export default function LoadingSpinner() {
  return (
    <div className={Styles.spinnerContainer}>
      <div className={Styles.loadingSpinner}></div>
    </div>
  );
}
